'use client';
import { useLocale, useTranslations } from 'next-intl';
import { GenericContent } from '@/src/types/aboutUs';
import Container from '@/src/components/ui/container';
import parse from 'html-react-parser';

export default function AboutUsPage({ data }: { data: GenericContent }) {
  const t = useTranslations('about-us');
  const currentLanguage = useLocale();

  return (
    <Container className="flex w-full flex-col py-8">
      <h1 className="text-2xl font-bold">{t('About PIK')}</h1>
      <div className="flex h-full py-10">
        {parse(currentLanguage === 'ar' ? data.arabicContent || '' : data.englsihContent || '')}
      </div>
    </Container>
  );
}
